"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UITooltipHeader;

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

function UITooltipHeader(_ref) {
  var className = _ref.className,
      children = _ref.children;
  return _react.default.createElement("h2", {
    className: (0, _classNames.default)('private-tooltip__heading', className)
  }, children);
}

UITooltipHeader.propTypes = {
  children: _react.PropTypes.node
};
UITooltipHeader.displayName = 'UITooltipHeader';
module.exports = exports.default;